<div class="container-fluid hero" [style.height]="height && height + 'rem'" [ngStyle]="{'background-image': backgroundImage && backgroundImage}">
    <div class="row justify-content-center gradient-overlay align-items-center h-100">
        <div class="col-auto text-center">
            <ng-content>
            </ng-content>
        </div>
    </div>
</div>
